import { IUserContext } from '@dataplace.ai/features'

export const getToken = async (authContext: IUserContext): Promise<string> => {
  const token = authContext.userData?.user?.getIdToken(true)?.then(response => response)
  return token || ''
}
